import useMagicIdUserWalletInfo from '@shared/hooks/useMagicIdUserWalletInfo';
import useWeb3, { RequestSignProps } from '@shared/hooks/web3/useWeb3';

export type SignProps = {
  walletSign: {
    message: string;
    pubKey: string;
    signature: string;
  };
};

export const useSignatureProps = () => {
  const { requestSign } = useWeb3();
  const { getUserWalletType } = useMagicIdUserWalletInfo();

  const getSignProps = async (signMessage: string): Promise<SignProps> => {
    const { walletType, userWallet } = getUserWalletType();

    const signProps: RequestSignProps = {
      walletType,
      message: signMessage,
      targetAddress: userWallet.attributes.address,
      signType: 'SIWE',
    };

    const results = await requestSign(signProps);

    if (!results) {
      throw new Error("Couldn't join the pool.");
    }

    const { message, address, signature } = results;

    return {
      walletSign: {
        message,
        pubKey: address,
        signature,
      },
    };
  };

  return { getSignProps };
};
